import { useMutation } from '@apollo/client'
import { useApolloClients } from 'lib/apollo/apolloProvider'
import {
  TUpdateAppConfigInput,
  TUpdateAppConfigResponse,
} from '../RoomView.types'
import { captureWarning } from 'lib/monitoring'
import { UPDATE_APP_CONFIG } from '../graphql/mutation'

export const useUpdateAppConfig = () => {
  const { iservicesClient: client } = useApolloClients()
  return useMutation<TUpdateAppConfigResponse, TUpdateAppConfigInput>(
    UPDATE_APP_CONFIG,
    {
      client,
      fetchPolicy: 'no-cache',
      onError: (error: Error) => {
        captureWarning(error)
      },
    }
  )
}
